import { Checkbox, CHECKBOX_SIZES, Radio } from 'cdk-radial';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { CHECKS_ONLY } from 'common/constants';
import { useAppSelector } from 'store/hooks';
import {
  getCheckNoInputError,
  setCheckNoInputError,
  setManualCheckNumber,
  setIsSequenceForFutureChecks
} from '../slice';
import { errorMessageChkSeq, labels } from './messages';
import { StyledInput, StyledRowInfo } from './styled';
import { DifferentCheckNoType } from './types';

export const DifferentCheckNo = ({
  setCheckNoInputValue,
  checkNoInputValue,
  setIsRadioOptionEnabled
}: DifferentCheckNoType): React.JSX.Element => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const checkNoInputError = useAppSelector(getCheckNoInputError);
  const [checkedOption, setCheckedOption] = useState<boolean>(false);
  const [radioOption, setRadioOption] = useState<boolean>(false);

  const handleCheckboxChange = ({
    target: { checked }
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      dispatch(setIsSequenceForFutureChecks(true));
    } else {
      dispatch(setIsSequenceForFutureChecks(null));
    }
    setCheckedOption(checked);
    setIsRadioOptionEnabled(checked);
  };

  const handleInputChange = ({
    target: { value }
  }: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9\b]+$/;
    if (value === '' || regex.test(value)) {
      setCheckNoInputValue(value);
      dispatch(setManualCheckNumber(value));
      dispatch(setCheckNoInputError(false));
    }
  };

  const handleRadioChange = ({
    target: { value }
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (value === CHECKS_ONLY) {
      setRadioOption(true);
      dispatch(setIsSequenceForFutureChecks(false));
    } else {
      setRadioOption(false);
      dispatch(setIsSequenceForFutureChecks(true));
    }
  };

  const handleOnBlur = () => {
    if (checkNoInputValue === '') {
      dispatch(setCheckNoInputError(true));
    }
  };

  return (
    <>
      <Checkbox
        checked={checkedOption}
        label={intl.formatMessage(labels.useDifferentCheckNo)}
        name="use-a-different-check-no"
        dataTestId="use-a-different-check-no"
        onChange={handleCheckboxChange}
        size={CHECKBOX_SIZES.LARGE}
      />
      {checkedOption && (
        <StyledRowInfo>
          <StyledInput
            hasError={checkNoInputError}
            enableCustomValidation
            errorMessage={intl.formatMessage(errorMessageChkSeq.checkNo)}
            id="input-for-check-no"
            dataTestId="input-for-check-no"
            isRequired
            label={intl.formatMessage(labels.checkNo)}
            name="input-check-no"
            onChange={handleInputChange}
            value={checkNoInputValue}
            onBlur={handleOnBlur}
          />
          <Radio
            dataTestId="radio-these-checks-only"
            checked={radioOption}
            id="radio-these-checks-only"
            label={intl.formatMessage(labels.theseChecksOnly)}
            name="radio-these-checks-only"
            onChange={handleRadioChange}
            size="standard"
            value={intl.formatMessage(labels.theseChecksOnly)}
          />
          <Radio
            dataTestId="radio-future-checks"
            checked={!radioOption}
            id="radio-future-checks"
            label={intl.formatMessage(labels.futureChecks)}
            name="radio-future-checks"
            onChange={handleRadioChange}
            size="standard"
            value={intl.formatMessage(labels.futureChecks)}
          />
        </StyledRowInfo>
      )}
    </>
  );
};
